import liff from "./liff";
import pad from "./pad";

export default axiosInstance => {
  return {
    liff: liff(axiosInstance),
    pad: pad(axiosInstance)
  };
};
